import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx'

export class Plus18 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            textHTML: null,
            loading: true
        }
    }

    componentDidMount() {
        casino.repos.casinoDocumentsRepo.get('opcapravila/plus18.html').then((dataHTML) => {
            this.setState({
                loading: false,
                textHTML: dataHTML
            });
        });
    }

    render() {
        return <div>
            <MetaTags title="Pravila 18+ | SuperSport Casino | SuperCasino" description="Super Sport vas moli da u igri ne prelazite granice vaših financijskih mogućnosti. Igrajte odgovorno." />
            <Header key="header" {...this.state} {...this.props}></Header>

            <div id="page-wrapper" className="white rules padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <div className="padding-sides-medium margin-center">
                    <div className="pravila-text-container">
                        {this.state.loading && <p>Učitavam sadržaj...</p>}
                        {!this.state.loading && this.state.textHTML && <div dangerouslySetInnerHTML={{ __html: this.state.textHTML }} />}
                    </div>
                </div>
            </div>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
};